import React, { useState } from "react";
import css from "./UserArea.module.scss";
import { infoIcon } from "../../../assets/icons";
import { Link } from "react-router-dom";
import { ModalAccompaniment } from "../Modals/ModalsPersonalArea/ModalAccompaniment/ModalAccompaniment";
import { ModalLicence } from "../Modals/ModalsPersonalArea/ModalLicense/ModalLicense";
import { linkToService } from "../../../constants/links";
import { LicenseCard } from "./LicenseCard/LicenseCard";
import { useGetAllLicenses } from "../../../hooks/license/useGetAllLicenses";
import { LoadingSpinner } from "../Spinner/LoadingSpinner";
import { Button } from "../Button/Button";
import { LicenseKeyModal } from "../../LicenseModals/LicenseKeyModal/LicenseKeyModal";
import Typography, { TypographyVariant } from "../../Typography/Typography";
import { useMyPermissions } from "../../../hooks/useMyPermissions";

type UserAreaProps = {
  data: {
    company: string;
    location: string;
    pilotStatus: boolean;
    pilotStatusExpirationDate: string;
  };
};

const UserArea = ({ data }: UserAreaProps) => {
  const { allLicenses, isAllLicensesFetching } = useGetAllLicenses();
  const { canView, canEdit } = useMyPermissions();
  // В матрице прав для "Личный кабинет" используются ключи USER_AREA_VIEW / USER_AREA_EDIT.
  // Для действий "редактирования" (добавить ключ/заявка) используем ТОЛЬКО атомарный ключ USER_AREA_EDIT.
  // Агрегированный USER_AREA может быть true по умолчанию (например для админов) и не должен давать edit-возможности.
  const canEditUserArea =
    canView("USER_AREA_EDIT") || canEdit("USER_AREA_EDIT");

  const [modalAccompanimentActive, setModalAccompanimentActive] =
    useState(false);
  const [modalLicenceActive, setModalLicenseActive] = useState(false);
  const [isAddLicenseModal, setIsAddLicenseModal] = useState(false);

  const { company, location } = data;
  // const handleButtonClickAccompaniment = () => {
  //   setModalAccompanimentActive(true);
  // };
  const handleButtonClickLicence = () => {
    setModalLicenseActive(true);
  };
  return (
    <div className={css.userAreaWrapper}>
      <ModalAccompaniment
        isActive={modalAccompanimentActive}
        setActive={setModalAccompanimentActive}
      />
      <ModalLicence
        isActive={modalLicenceActive}
        setActive={setModalLicenseActive}
      />
      <div className={css.title}>Личный кабинет</div>
      <div className={css.categoryWrapper}>
        <Typography
          variant={TypographyVariant.h4_regular}
          className={css.category}
        >
          Название организации:
          <span>{company}</span>
        </Typography>
        <Typography
          variant={TypographyVariant.h4_regular}
          className={css.category}
        >
          Название объекта:
          <span>{location}</span>
        </Typography>
      </div>

      <div className={css.subTitleWrapper}>
        <div className={css.subTitle}>Лицензия</div>
        <img
          src={infoIcon}
          className={css.infoIcon}
          alt="infoIcon"
          onClick={handleButtonClickLicence}
        />
      </div>

      {isAllLicensesFetching ? (
        <div className={css.loaderContainer}>
          <LoadingSpinner />
        </div>
      ) : (
        <div className={css.licensesContainer}>
          {allLicenses?.map((license) => (
            <LicenseCard
              key={license.keyName}
              licenseType={license.type}
              licenseKey={license.keyName}
              isActive={license.active}
              startTime={license.dateFrom}
              endTime={license.dateTo}
            />
          ))}
        </div>
      )}

      {canEditUserArea && (
        <Button
          content="Добавить новый ключ"
          btnStyle={"blue"}
          onClick={() => {
            setIsAddLicenseModal(true);
          }}
          className={css.addButton}
        />
      )}

      {/* <div className={css.subTitleWrapper}>
        <div className={css.subTitle}>Сопровождение</div>
        <img
          src={infoIcon}
          className={css.infoIcon}
          alt="infoIcon"
          onClick={handleButtonClickAccompaniment}
        />
      </div>

      <div className={css.categoryWrapper}>
        <div className={css.category}>
          <span>Статус услуги сопровождения:</span>
          <StatusCard status={pilotStatus} content={'Статус услуги сопровождения'} />
        </div>
        <div className={css.category}>
          <span>Срок окончания:</span>
          <span>{pilotStatusExpirationDate}</span>
        </div>
      </div> */}

      {canEditUserArea && (
        <Link className={css.linkToService} to={linkToService}>
          ЗАЯВКА НА СЕРВИСНОЕ ОБСЛУЖИВАНИЕ
        </Link>
      )}

      {isAddLicenseModal && (
        <LicenseKeyModal onClose={() => setIsAddLicenseModal(false)} />
      )}
    </div>
  );
};

export default UserArea;
